import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class SaveLeadHitUserUseCase extends UseCase {
  constructor({config, leadHitUserVOFactory, saveLeadHitUserService}) {
    super()
    this._config = config
    this._leadHitUserVOFactory = leadHitUserVOFactory
    this._saveLeadHitUserService = saveLeadHitUserService
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async execute({adId, contractId, leadType}) {
    const leadHitVO = this._leadHitUserVOFactory({
      config: this._config,
      adId,
      contractId,
      leadType
    })

    const [error, leadHit] = await this._saveLeadHitUserService.execute(leadHitVO)

    if (error) return Promise.reject(error)
    return leadHit.toJSON()
  }
}
